import { Injectable } from '@angular/core'

import { HttpService } from './http.service'

import {  } from '../dto/card-information.dto'
import { MembershipPointDto } from '../dto/order.dto'

@Injectable()
export class MembershipPointService {
  constructor(
    private httpService: HttpService) {
  }
  async findMembershipPoint() {
    return await this.httpService.get<MembershipPointDto[]>(`/merchant/v1/membership-points`)
  }

  async updateMembershipPoint(id: string, { pointPerDollar }: MembershipPointDto) {
    return await this.httpService.post<boolean>(`/merchant/v1/membership-points/${id}`, { pointPerDollar })
  }

  async setEnabledMembershipPoint(id: string, enabled: boolean) {
    if (enabled) {
      return await this.httpService.put<boolean>(`/merchant/v1/membership-points/${id}/enabled`)
    }

    return await this.httpService.put<boolean>(`/merchant/v1/membership-points/${id}/disabled`)
  }
}
